import React from "react";

export interface IStringContext {
  jumpToNavigation: string;
  index_errorboundary_message: string;
  general_errorboundary_message: string;
  jump_to_content: string;
  loanCalculator: string;
  loanCalculator_AnnuityText: string;
  loanCalculator_SerialText: string;
  loanCalculator_Calculation: string;
  loanCalculator_EffInterest: string;
  loanCalculator_SetupFee: string;
  loanCalculator_ExampleText: string;
  loanCalculator_Interest: string;
  loanCalculator_OfWhichInterest: string;
  loanCalculator_Invoice: string;
  loanCalculator_FirstInvoice: string;
  loanCalculator_Loan: string;
  loanCalculator_AmountToPay: string;
  loanCalculator_NominalInterest: string;
  loanCalculator_OutstandingDebt: string;
  loanCalculator_Payment: string;
  loanCalculator_PeriodInterestCost: string;
  loanCalculator_RepaymentPeriod: string;
  loanCalculator_RepaymentPlan: string;
  loanCalculator_SendRepaymentPlanEmail: string;
  loanCalculator_Summary: string;
  loanCalculator_InstallmentFee: string;
  loanCalculator_TotalAmount: string;
  loanCalculator_year: string;
  loanCalculator_years: string;
  loanCalculator_LoanCost: string;
  loanCalculator_LoanTotalCost: string;
  loanCalculator_YearlyNominalInterest: string;
  loanCalculator_DisclaimerText: string;
  repaymentPlan_Month: string;
  repaymentPlan_Interest: string;
  repaymentPlan_TermFee: string;
  repaymentPlan_Payment: string;
  repaymentPlan_Total: string;
  repaymentPlan_January: string;
  repaymentPlan_February: string;
  repaymentPlan_March: string;
  repaymentPlan_April: string;
  repaymentPlan_May: string;
  repaymentPlan_June: string;
  repaymentPlan_July: string;
  repaymentPlan_August: string;
  repaymentPlan_September: string;
  repaymentPlan_October: string;
  repaymentPlan_November: string;
  repaymentPlan_December: string;
  goToFrontPage: string;
  publishInfo_Published: string;
  publishInfo_Updated: string;
  publishInfo_WrittenBy: string;
  publishInfo_ReadTimePlural: string;
  publishInfo_ReadTimeSingle: string;
  publishInfo_ReadTime: string;
  tableOfContents_heading: string;
  customerServiceChat_loginPromptText: string;
  customerServiceChat_loginPromptLinkLabel: string;
  customerServiceChat_authSearchPlaceholder: string;
}

export const defaultValues: IStringContext = {
  index_errorboundary_message: "",
  general_errorboundary_message: "",
  jump_to_content: "",
  loanCalculator: "",
  loanCalculator_AnnuityText: "",
  loanCalculator_SerialText: "",
  loanCalculator_Calculation: "",
  loanCalculator_EffInterest: "",
  loanCalculator_SetupFee: "",
  loanCalculator_ExampleText: "",
  loanCalculator_Interest: "",
  loanCalculator_OfWhichInterest: "",
  loanCalculator_Invoice: "",
  loanCalculator_FirstInvoice: "",
  loanCalculator_Loan: "",
  loanCalculator_AmountToPay: "",
  loanCalculator_NominalInterest: "",
  loanCalculator_OutstandingDebt: "",
  loanCalculator_Payment: "",
  loanCalculator_PeriodInterestCost: "",
  loanCalculator_RepaymentPeriod: "",
  loanCalculator_RepaymentPlan: "",
  loanCalculator_SendRepaymentPlanEmail: "",
  loanCalculator_Summary: "",
  loanCalculator_InstallmentFee: "",
  loanCalculator_TotalAmount: "",
  loanCalculator_year: "",
  loanCalculator_years: "",
  loanCalculator_LoanCost: "",
  loanCalculator_LoanTotalCost: "",
  loanCalculator_YearlyNominalInterest: "",
  loanCalculator_DisclaimerText: "",
  repaymentPlan_Month: "",
  repaymentPlan_Interest: "",
  repaymentPlan_TermFee: "",
  repaymentPlan_Payment: "",
  repaymentPlan_Total: "",
  repaymentPlan_January: "",
  repaymentPlan_February: "",
  repaymentPlan_March: "",
  repaymentPlan_April: "",
  repaymentPlan_May: "",
  repaymentPlan_June: "",
  repaymentPlan_July: "",
  repaymentPlan_August: "",
  repaymentPlan_September: "",
  repaymentPlan_October: "",
  repaymentPlan_November: "",
  repaymentPlan_December: "",
  goToFrontPage: "",
  jumpToNavigation: "",
  publishInfo_Published: "",
  publishInfo_Updated: "",
  publishInfo_WrittenBy: "",
  publishInfo_ReadTimePlural: "",
  publishInfo_ReadTimeSingle: "",
  publishInfo_ReadTime: "",
  tableOfContents_heading: "",
  customerServiceChat_loginPromptText: "",
  customerServiceChat_loginPromptLinkLabel: "",
  customerServiceChat_authSearchPlaceholder: "",
};

export const StringContext = React.createContext<IStringContext>(defaultValues);
